import { render } from "./IdentificacaoFacial.vue?vue&type=template&id=1644ea16&scoped=true"
import script from "./IdentificacaoFacial.vue?vue&type=script&lang=js"
export * from "./IdentificacaoFacial.vue?vue&type=script&lang=js"

import "./IdentificacaoFacial.vue?vue&type=style&index=0&id=1644ea16&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1644ea16"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QToggle,QSelect,QIcon,QBtn});
